import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DoodleBugLanding from "./components/DoodleBugLanding";
import AdminPanel from "./components/AdminPanel";
import AdminLogin from "./components/AdminLogin";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function App() {
  const [adminToken, setAdminToken] = useState(null);
  const [showAdmin, setShowAdmin] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("admin") === "true") {
      const stored = sessionStorage.getItem("adminToken");
      if (stored) {
        setAdminToken(stored);
        setShowAdmin(true);
      } else {
        setShowAdmin(true);
      }
    }
  }, []);

  const handleLogin = async (password) => {
    const res = await fetch(`${BACKEND_URL}/api/admin/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password }),
    });
    if (!res.ok) throw new Error("Invalid password");
    const data = await res.json();
    sessionStorage.setItem("adminToken", data.token);
    setAdminToken(data.token);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("adminToken");
    setAdminToken(null);
    setShowAdmin(false);
    window.history.replaceState({}, "", "/");
  };

  if (showAdmin) {
    if (!adminToken) {
      return (
        <div className="App">
          <AdminLogin onLogin={handleLogin} onBack={handleLogout} />
        </div>
      );
    }
    return (
      <div className="App">
        <AdminPanel token={adminToken} onBack={handleLogout} onAuthError={handleLogout} />
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DoodleBugLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
